import WebSeries from 'umg-ember-backend/components/record-explorer/for/web-series';

<template><WebSeries @records={{@model}} @recordType='web-series' /></template>
